// Campus photo for /colleges/yeshiva-university: CC BY-SA 4.0, by Beyond My Ken, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AYeshiva_University_Schottenstein_Center.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/yeshiva-university/; credited under the photo.
const photo = {
    "slug": "yeshiva-university",
    "alt": "The red brick Schottenstein Center, with its columned facade, at Yeshiva University in Washington Heights, New York City",
    "src": "/colleges/yeshiva-university/campus-1600.webp",
    "srcSmall": "/colleges/yeshiva-university/campus-800.webp",
    "srcMid": "/colleges/yeshiva-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/yeshiva-university/og.jpg",
    "title": "Yeshiva University Schottenstein Center",
    "author": "Beyond My Ken",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AYeshiva_University_Schottenstein_Center.jpg",
    "read": "2026-10-01"
};

export default photo;
